module.exports = __webpack_public_path__ + "static/media/Nguyen_Thuy_Dung.18d51fb0.jpg";